import React from 'react';
import * as s from './styled-auth-field';

// AuthField — input estilizado pra telas de autenticacao
// (/login, /signup, /forgot-password, /reset-password). Match exato
// com o design Login.html: icone leading, padding gordo, focus halo
// cyan, suporte a $error pra estado vermelho.
//
// Pra evitar duplicar a estrutura ctrl+input em N telas, esse component
// abstrai. Aceita um children extra que vai renderizado APOS o input
// (ex: ToggleEye pra senha).
//
// Props:
//   leadIcon: ReactNode (svg) — icone a esquerda do input
//   label: string — texto do label (CAPS via CSS)
//   labelExtra: ReactNode — extra na linha do label (link ou hint)
//   error: boolean — pinta borda vermelha + halo
//   hint: ReactNode — texto/elemento abaixo do input (erro/warning/info)
//   hintId: string — id pra aria-describedby
//   inputProps: passados pro <input>
//   trailing: ReactNode — renderizado apos o input (ex: ToggleEye)
const AuthField = React.forwardRef(
  (
    {
      leadIcon,
      label,
      labelExtra,
      error,
      hint,
      hintId,
      trailing,
      inputProps = {},
    },
    ref,
  ) => (
    <s.Field $error={error}>
      <s.FieldLabel>
        {label}
        {labelExtra}
      </s.FieldLabel>
      <s.Ctrl>
        {leadIcon}
        <input
          ref={ref}
          aria-invalid={!!error}
          aria-describedby={hintId || undefined}
          {...inputProps}
        />
        {trailing}
      </s.Ctrl>
      {hint}
    </s.Field>
  ),
);

AuthField.displayName = 'AuthField';

export default AuthField;
